// Shipped modifier catalog — a stable, few-dozen-code lookup, defensible as a constant
// (unlike ICD-10, which has no dictionary). Needs an annual review against CMS.
export const MODIFIER_CATALOG = [
  ["22", "Increased procedural services"],
  ["24", "Unrelated E/M during a postoperative period"],
  ["25", "Significant, separately identifiable E/M same day"],
  ["26", "Professional component"],
  ["27", "Multiple outpatient E/M encounters same day"],
  ["33", "Preventive service"],
  ["47", "Anesthesia by surgeon"],
  ["50", "Bilateral procedure"],
  ["51", "Multiple procedures"],
  ["52", "Reduced services"],
  ["53", "Discontinued procedure"],
  ["54", "Surgical care only"],
  ["55", "Postoperative management only"],
  ["56", "Preoperative management only"],
  ["57", "Decision for surgery"],
  ["58", "Staged/related procedure during postop period"],
  ["59", "Distinct procedural service"],
  ["62", "Two surgeons"],
  ["63", "Procedure on infant < 4 kg"],
  ["66", "Surgical team"],
  ["76", "Repeat procedure by same physician"],
  ["77", "Repeat procedure by another physician"],
  ["78", "Unplanned return to OR during postop period"],
  ["79", "Unrelated procedure during postop period"],
  ["80", "Assistant surgeon"],
  ["81", "Minimum assistant surgeon"],
  ["82", "Assistant surgeon (no resident available)"],
  ["90", "Reference (outside) laboratory"],
  ["91", "Repeat clinical diagnostic lab test"],
  ["92", "Alternative lab platform testing"],
  ["95", "Synchronous telemedicine service"],
  ["GT", "Via interactive audio and video telecom"],
  ["GQ", "Via asynchronous telecommunications"],
  ["GA", "Waiver of liability statement on file"],
  ["GX", "Notice of liability issued, voluntary"],
  ["GY", "Item/service statutorily excluded"],
  ["GZ", "Item/service expected to be denied"],
  ["LT", "Left side"],
  ["RT", "Right side"],
  ["E1", "Upper left eyelid"],
  ["E2", "Lower left eyelid"],
  ["E3", "Upper right eyelid"],
  ["E4", "Lower right eyelid"],
  ["F1", "Left hand, second digit"],
  ["FA", "Left hand, thumb"],
  ["TA", "Left foot, great toe"],
  ["XE", "Separate encounter"],
  ["XS", "Separate structure"],
  ["XP", "Separate practitioner"],
  ["XU", "Unusual non-overlapping service"],
];
export const MODIFIER_NAME = Object.fromEntries(MODIFIER_CATALOG);
